import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export type AddonAvailability = {
  id: string;
  name: string;
  rentalPrice: number;
  totalQuantity: number;
  availableQuantity: number;
  currency: string;
};

export type AddonSelection = {
  addonId: string;
  quantity: number;
};

export function useAvailableAddons(params: {
  locationId: string;
  sportCode: string;
  startTime: string;
  endTime: string;
} | null) {
  return useQuery({
    queryKey: ['addons', params],
    queryFn: () => {
      const p = params!;
      const qs = new URLSearchParams({
        locationId: p.locationId,
        sportCode: p.sportCode,
        startTime: p.startTime,
        endTime: p.endTime,
      });
      return apiClient<AddonAvailability[]>(`/addons?${qs}`, { skipAuth: true });
    },
    enabled: !!params?.startTime && !!params?.endTime,
  });
}
